export const walletMessages = {
  wallet: ['Кошелёк', 'Wallet', 'Pul kisəsi'],
  balance: ['Баланс', 'Balance', 'Balans'],
  topup: ['Пополнить', 'Top up', 'Balansı artır'],
  withdraw: ['Вывести', 'Withdraw', 'Çıxar'],
  myQr: ['Мой QR', 'My QR', 'Mənim QR kodum'],
  scanQr: ['Сканировать QR', 'Scan QR', 'QR kodunu skan et'],
  qrInvalid: [
    'Не удалось распознать QR',
    'QR code not recognized',
    'QR kodu tanınmadı',
  ],
  qrHint: [
    'Для перевода Kelvin с мобильного приложения',
    'Receive Kelvin from the mobile app',
    'Mobil tətbiqdən Kelvin qəbul edin',
  ],
  referral: ['Пригласить друга', 'Invite a friend', 'Dostunu dəvət et'],
  history: ['История операций', 'Transaction history', 'Əməliyyat tarixçəsi'],
  withdrawals: ['История выводов', 'Withdrawals', 'Çıxarış tarixçəsi'],
  income: ['Доходы', 'Income', 'Gəlirlər'],
  expenses: ['Расходы', 'Expenses', 'Xərclər'],
  today: ['Сегодня', 'Today', 'Bu gün'],
  yesterday: ['Вчера', 'Yesterday', 'Dünən'],
  earlier: ['Ранее', 'Earlier', 'Əvvəllər'],
  fromDate: ['С даты', 'From date', 'Tarixdən'],
  toDate: ['По дату', 'To date', 'Tarixədək'],
  reset: ['Сбросить', 'Reset', 'Sıfırla'],
  apply: ['Применить', 'Apply', 'Tətbiq et'],
  friends: ['Друзья', 'Friends', 'Dostlar'],
  allUsers: ['Все пользователи', 'All users', 'Bütün istifadəçilər'],
  recipient: ['Получатель', 'Recipient', 'Alıcı'],
  amount: ['Сумма, K', 'Amount, K', 'Məbləğ, K'],
  insufficient: [
    'Недостаточно Kelvin',
    'Not enough Kelvin',
    'Kifayət qədər Kelvin yoxdur',
  ],
  recipientUnverified: [
    'Операция недоступна: пользователь не прошёл верификацию',
    'The recipient must be verified',
    'Alıcı təsdiqlənməlidir',
  ],
  transferDone: ['Перевод отправлен', 'Transfer sent', 'Köçürmə göndərildi'],
  verification: ['Верификация', 'Verification', 'Təsdiqləmə'],
  verified: ['Профиль подтверждён', 'Profile verified', 'Profil təsdiqlənib'],
  kycContext: [
    'Пройдите верификацию, чтобы переводить и выводить Kelvin',
    'Verify your identity to send and withdraw Kelvin',
    'Kelvin göndərmək və çıxarmaq üçün kimliyinizi təsdiqləyin',
  ],
  kycIntro: [
    'Подтвердите, что вы — это вы',
    'Confirm your identity',
    'Kimliyinizi təsdiqləyin',
  ],
  kycPrepare: [
    'Выберите светлое место, снимите очки и головной убор. Держите лицо в кадре. Разрешите камеру в настройках браузера.',
    'Choose a well-lit place, remove glasses and headwear. Keep your face in the frame. Allow camera access in browser settings.',
    'İşıqlı yer seçin, eynək və baş geyimini çıxarın. Üzünüzü kadrda saxlayın. Brauzer ayarlarında kameraya icazə verin.',
  ],
  kycConsent: [
    'Я согласен пройти проверку личности у провайдера верификации.',
    'I agree to an identity check by the verification provider.',
    'Təsdiqləmə provayderində şəxsiyyət yoxlamasına razıyam.',
  ],
  kycWaiting: [
    'Завершите проверку в открывшемся окне. Результат появится здесь.',
    'Complete verification in the new window. The result will appear here.',
    'Açılan pəncərədə təsdiqləməni tamamlayın. Nəticə burada görünəcək.',
  ],
  kycDuplicate: [
    'Это лицо уже связано с другим аккаунтом',
    'This face is already linked to another account',
    'Bu üz artıq başqa hesabla əlaqələndirilib',
  ],
  kycRejected: [
    'Проверка не пройдена. Попробуйте ещё раз.',
    'Verification failed. Please try again.',
    'Təsdiqləmə uğursuz oldu. Yenidən cəhd edin.',
  ],
  agree: ['Согласен', 'I agree', 'Razıyam'],
  decline: ['Отказаться', 'Decline', 'İmtina et'],
  card: ['На карту', 'Bank card', 'Bank kartına'],
  sbp: ['По СБП', 'Phone transfer', 'Telefonla köçürmə'],
  pan: ['Номер карты', 'Card number', 'Kart nömrəsi'],
  phone: ['Телефон получателя', 'Recipient phone', 'Alıcının telefonu'],
  firstName: ['Имя получателя', 'First name', 'Alıcının adı'],
  lastName: ['Фамилия получателя', 'Last name', 'Alıcının soyadı'],
  debitConfirm: [
    'С баланса спишется {{amount}} K',
    '{{amount}} K will be debited',
    'Balansdan {{amount}} K çıxılacaq',
  ],
  receiptEmail: [
    'Email для чека (необязательно)',
    'Receipt email (optional)',
    'Qəbz üçün email (istəyə görə)',
  ],
  paymentPending: [
    'Платёж обрабатывается',
    'Payment is processing',
    'Ödəniş emal edilir',
  ],
  paymentNewWarning: [
    'Новое пополнение будет отдельным платежом',
    'A new top-up is a separate payment',
    'Yeni balans artırma ayrıca ödənişdir',
  ],
  paymentDone: [
    'Баланс пополнен · Зачислено {{amount}} K',
    'Balance topped up · {{amount}} K credited',
    'Balans artırıldı · {{amount}} K köçürüldü',
  ],
  paymentFailed: ['Платёж отклонён', 'Payment declined', 'Ödəniş rədd edildi'],
  topupUnavailable: [
    'Пополнение временно недоступно',
    'Top-ups are temporarily unavailable',
    'Balans artırma müvəqqəti əlçatmazdır',
  ],
  withdrawUnavailable: [
    'Вывод временно недоступен',
    'Withdrawals are temporarily unavailable',
    'Pul çıxarma müvəqqəti əlçatmazdır',
  ],
  order: ['Номер операции', 'Operation number', 'Əməliyyat nömrəsi'],
  refunded: [
    'Kelvin возвращены на баланс',
    'Kelvin returned to your balance',
    'Kelvin balansa qaytarılıb',
  ],
  status_NEW: ['Создана', 'Created', 'Yaradılıb'],
  status_ACCEPTED: ['Принята', 'Accepted', 'Qəbul edilib'],
  status_PENDING: ['В обработке', 'Processing', 'Emal edilir'],
  status_DONE: ['Выплачено', 'Paid', 'Ödənilib'],
  status_REJECTED: ['Отклонена', 'Rejected', 'Rədd edilib'],
  status_ERROR: ['Ошибка выплаты', 'Payment error', 'Ödəniş xətası'],
  subscription: ['Подписка Aura', 'Aura subscription', 'Aura abunəliyi'],
  dailyBonus: ['Ежедневный бонус', 'Daily bonus', 'Gündəlik bonus'],
  claim: ['Забрать бонус', 'Claim bonus', 'Bonusu al'],
  claimed: ['Уже получено', 'Already claimed', 'Artıq alınıb'],
  returnToOrder: ['Вернуться к оформлению', 'Return to checkout', 'Sifarişə qayıt'],
} satisfies Record<string, readonly [string, string, string]>;
